/*
 * 苏州海管家物流科技有限公司（https://www.hgj.com/）.
 * 苏公网安备32059002003385号 © 2015-2023 Hgj.com All Rights Reserved. | 苏ICP备15030950号.
 * @Date: 2023.09.05.
 * @Author
 * @Description 恪保 - 公用 方法 定义 功能性 .
 **/
import dayjs from 'dayjs'
import router from '../router'
import { ElMessage } from '@hgj/element-plus'
import { ElMessageBox } from '@hgj/element-plus/es'
import { useAuthStore } from '@/store/authStore'
import { projectEnvironment } from '@/utils/common'
import {
  FormCode,
  FormCodeIsGlobal,
  isGlobal,
  jointPlatformDomain,
  ProductCode,
} from '@/utils/constant'
import { clearStorage } from '@/utils/storage'
import { DynamicFieldDetail } from '@/api/dynamic-form'
import { getWebTrackerInstance } from '@hgj/storybrooke-business-tracker'
import { i18n } from '@/i18n'
const t = i18n.global.t

/**
 *@Description 请求 前 接口所需 参数 处理 函数 .
 *@Return .
 **/
export const axiosQwRequest = async () => {
  const { getToken } = await useAuthStore()

  return {
    'access-token': getToken || '',
  }
}
/**
 *@Description 请求 返回 结果 处理 函数 .
 *@Return .
 **/
export const axiosQwResponse = async (
  code: number,
  message: string,
  data?: any,
  response?: any,
) => {
  await ElMessage.closeAll()
  if (code === 401) {
    console.log('401')
    await clearStorage()
    // gotoLogin()
    await router.push('/home') // 去 出口 货运 险
  } else if (code === 800003010) {
    return ElMessage.warning(t('utils.contactServiceOrOpen'))
  } else if (code === 400003) {
    console.log('进入了4 0 0 0 0 3', message)
    return ElMessage.warning(message)
  } else if (code === 403) {
    return ElMessage.warning(t('utils.noPermissionRelogin'))
  } else if (code === 800003005) {
    // 暂无 权限 去 home 页面
    await router.push('/home') // 去 出口 货运 险
    return false
  } else if (code === 800003004) {
    ElMessage.warning(message)
    return false
  } else if (code === 100000) {
    // code=10000="用户未绑定邮箱"
    return Promise.reject(response.data)
  } else if (code === 100001) {
    // code=10001="用户开票信息尚未补充完整"
    return Promise.reject(response.data)
  } else if (code === 100002) {
    await router.push('/') // 去 出口 货运 险
    ElMessage.warning(t('utils.enterpriseStopped'))
    return false
  } else {
    const tracker = getWebTrackerInstance()
    tracker?.track?.(
      'responseError',
      t('utils.requestResponseError'),
      'error',
      { error: message },
    )
    ElMessage.error(message)
    return Promise.reject(data)
  }
}
/**
 *@Description 返回 不同环境下的 登录 域名 .
 *@Return .
 **/
export const returnLoginDomain = (str?: string) => {
  const environment: string = projectEnvironment()
  const origin = jointPlatformDomain[environment]
  const eUrl = eDomain[environment]
  return str || `${origin}/login/wx?redirect_url=${eUrl}`
}
/**
 *@Description 获取中台 的token 之后 重定向 到 指定页面 .
 *@Return .
 **/
export const eDomain: Record<string, string> = {
  'prod-': 'https://safer.hgj.com',
  'dev-': 'https://dev-safer.hgj.com',
  'beta-': 'https://beta-safer.hgj.com',
}
/**
 *@Description 格式化 - 时间 - 年月日 .
 *@Return .
 **/
export const formatYMD = (val: string) => {
  return val ? dayjs(val).format('YYYY-MM-DD') : val || ''
}
/**
 *@Description 格式化 - 时间 .
 *@Return 将时间格式是：YYYY-MM-DD 转成 xx天 / x月x日.
 **/
export const formatDay = (val: string) => {
  let str = `${val.slice(5)}`
  const { tomorrow, afterT, threeDays } = formatThreeDays()

  if (tomorrow === val) {
    str = `${t('utils.tomorrow')} / ${str}`
  } else if (afterT === val) {
    str = `${t('utils.dayAfterTomorrow')} / ${str}`
  } else if (threeDays === val) {
    str = `${t('utils.threeDaysLater')} / ${str}`
  }

  return str
}
export const formatThreeDays = (isNow = false) => {
  const now = dayjs().format('YYYY-MM-DD')
  const one = dayjs().add(1, 'day')
  const two = dayjs().add(2, 'day')
  const thr = dayjs().add(3, 'day')

  const tomorrow = formatYMD(one.toString())
  const afterT = formatYMD(two.toString())
  const threeDays = formatYMD(thr.toString())

  const obj: Record<string, unknown> = {
    tomorrow,
    afterT,
    threeDays,
  }
  if (isNow) {
    obj.now = now
    obj.today = now
  }

  return obj
}
/**
 *@Description  .
 *@Return .
 **/
export const EBoxConfirm = (
  data: {
    content: string
    title: string
    confirmText: string
    cancelText: string
  },
  confirmCall: () => void,
  cancelCall?: () => void,
) => {
  try {
    ElMessageBox.confirm(data?.content || '', data?.title, {
      type: 'warning',
      confirmButtonText: data?.confirmText || '确认',
      cancelButtonText: data?.cancelText || '取消',
    })
      .then(() => {
        confirmCall && confirmCall()
      })
      .catch(() => {
        cancelCall && cancelCall()
      })
  } catch (action) {
    ElMessage(`${t('utils.cancelled')} 【${action}】`)
    return
  }
}
/**
 * 消息提示框
 */
export const HgjMsg = (
  message: string,
  type: 'warning' | 'success' = 'warning',
  duration = 2000,
) => {
  ElMessage({
    message,
    type,
    duration,
  })
}

// 是否无效邮箱
export const invalidEmail = (email: string) => {
  const reg = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/
  return !reg.test(email)
}

export const downloadFile = (url: string, fileName: string) => {
  const xml = new XMLHttpRequest()
  xml.open('GET', url, true)
  xml.responseType = 'blob'
  xml.onload = function () {
    const r_url = window.URL.createObjectURL(xml.response)
    const a = document.createElement('a')
    a.href = r_url
    a.download = fileName
    // 使用a标签批量下载文件时最好使用_blank，否则只会下载最后一个文件
    a.setAttribute('target', '_blank')
    a.click()
    a.remove()
  }
  xml.send()
}

export const downFile = (blob: any, fileName: string) => {
  const newBlob = new Blob([blob])
  const elink = document.createElement('a')
  elink.href = window.URL.createObjectURL(newBlob)
  elink.download = fileName
  elink.style.display = 'none'
  document.body.appendChild(elink)
  elink.click()
  document.body.removeChild(elink)
  URL.revokeObjectURL(elink.href) // 释放URL 对象
}

export const isJSON = (str: any) => {
  try {
    JSON.parse(str)
    return true
  } catch (error) {
    return false
  }
}

export interface IDynamicField {
  /** 是否显示 */
  show: boolean
  /** 是否必填 */
  required: boolean
  /** 字段属性 */
  property: string
  /** 排序索引 */
  sortIndex: number
  /** 扩展数据 */
  extData: Record<string, any>
  /** 表单项属性 */
  formItemProps: Record<string, any>
  /** 组件属性 */
  componentProps: Record<string, any>
}

const diffTypeMap: Record<string, 'number' | 'string'> = {
  addition: 'number',
}

/**
 * 创建动态表单字段
 * @param fields 字段列表
 * @returns 动态表单配置对象
 */
export const createDynamicFields = (
  fields: DynamicFieldDetail[],
  callback?: (field: DynamicFieldDetail) => DynamicFieldDetail,
) => {
  const dynamicFields = fields.reduce(
    (acc: Record<string, any>, _field: DynamicFieldDetail) => {
      const field = callback ? callback(_field) : _field
      let extData = {}
      try {
        extData = JSON.parse(field?.extJson || '{}')
      } catch (e) {
        console.warn('extJson 解析失败:', e)
      }
      const rules = []
      const required = field.required === 1
      if (required) {
        rules.push({
          required: true,
          trigger: ['blur'],
          validator: (
            rule: any,
            value: null | undefined,
            callback: (arg0?: Error | undefined) => void,
          ) => {
            if (
              value === undefined ||
              value === null ||
              String(value).trim() === ''
            ) {
              return callback(
                new Error(t('utils.notEmpty', { name: field.showName })),
              )
            }
            callback()
          },
        })
      }
      const residualRules =
        JSON.parse(field?.regular || '[]').map((item: any) => ({
          pattern: item,
          message:
            field?.errorMessageJson ||
            t('utils.ruleMismatch', { name: field.showName }),
          type: diffTypeMap[field.property] || 'string',
          trigger: ['blur', 'change'],
        })) || []
      const formItemProps = {
        label: field.showName,
        prop: field.property,
        rules: [...rules, ...residualRules],
      }
      const componentProps = {
        type: field.type,
        placeholder: field.placeholder,
        disabled: field.editType === 0,
        showName: field.showName,
        maxlength: field.length,
        labelWidth: field.width,
      }
      acc[field.property] = {
        show: !!field.show,
        required,
        property: field.property,
        sortIndex: field.sortIndex,
        extData,
        formItemProps,
        componentProps,
      }
      return acc
    },
    {},
  )
  return dynamicFields as Record<string, IDynamicField>
}

/**
 * 处理文件列表
 * @param files 文件列表
 * @returns 处理后的文件列表
 */
export const handleDealFileMap = (files: any) => {
  return files.map((it: any) => {
    const item = {
      name: it.fileName,
      nasInfo: {
        ...it,
      },
      response: {
        data: {
          fileId: it.nasId,
        },
      },
      ...it,
    }
    return item
  })
}

export const formatFileList = (filesRes: any) => {
  return (filesRes || [])?.map((it: any) => {
    const { nasFileId } = it?.response?.data || {}
    const nasId = nasFileId || it.nasInfo?.nasId || it.nasId
    return {
      ...(it?.data || {}),
      ...(it?.nasInfo || {}),
      fileUrl: `https:${import.meta.env.VITE_APP_NAS_PREV_URL}/pass/proxy/${nasId}`,
      fileName: it.name,
      nasId: nasId,
    }
  })
}

/**
 * 通过地址栏参数productCode获取正确的表单配置
 * @returns
 */
export const getFormCode = (productCode: ProductCode) => {
  const currentProductCode = isGlobal ? FormCodeIsGlobal : FormCode
  switch (productCode) {
    case ProductCode.DOMESTIC_HAZARD:
      return currentProductCode.inner_insure_add
    case ProductCode.EXPORT_HAZARD:
      return currentProductCode.export_insure_add
    case ProductCode.IMPORT_HAZARD:
      return currentProductCode.insure_add
    default:
      return ''
  }
}

/**
 * 获取正确的表单配置
 * @param params 参数
 * @param params.supplyCode 供应商代码(HGJ)
 * @param params.channelCode 通道代码(RB/PA-SH....)
 * @param params.outputType 输出类型(IMPORT:进口，EXPORT:出口，INNER:国内)
 * @param params.opstatus 操作状态(批改的话就传change，否则为空)
 * @returns
 */
export const getFormCodeByRow = (params: {
  supplyCode?: string
  channelCode: string
  outputType: 'IMPORT' | 'EXPORT' | 'INNER'
  opstatus?: string
}) => {
  const { supplyCode, channelCode, outputType, opstatus } = params
  return `${supplyCode || 'HGJ'}-${channelCode}-${outputType}${opstatus ? `-${opstatus}` : ''}`
}

/**
 * 计算保险金额
 * @param cargoValue 货物价值
 * @param addition 加成比例
 * @param isDomestic 是否为国内货运险
 * @returns 格式化后的保险金额字符串
 */
export const calculateInsuranceAmount = (
  cargoValue: number,
  addition: number,
  isDomestic: boolean,
): string => {
  const value = cargoValue || 0
  // 判断是否为国内货运险，如果是则不需要乘以加成比例
  if (isDomestic) {
    return isNaN(value) ? '0.00' : Number(value)?.toFixed?.(2)
  } else {
    const additionRate = addition / 100 || 0
    const result = value * additionRate
    return isNaN(result) ? '0.00' : Number(result)?.toFixed?.(2)
  }
}
